import walletBalanceIcon from './airtimePageAssets/wallet-balance.svg';
import monthlySpendingIcon from './airtimePageAssets/monthly-spending.svg';
import totalPurchaseIcon from './airtimePageAssets/total_purchase.svg';
import earnedRewardsIcon from './referralPageAssets/earned-rewards-icon.svg';
import referralsSentIcon from './referralPageAssets/referrals-sent-icon.svg';
import verifiedStoresIcon from './referralPageAssets/verified-store-icon.svg';
import addProductsIcon from './dashboardHomePageAssets/add_product_icon.svg';
import viewOrdersIcon from './dashboardHomePageAssets/view_orders_icon.svg';
import createAdsIcon from './dashboardHomePageAssets/create_ads_icon.svg';
import checkChatIcon from './dashboardHomePageAssets/check_chat_icon.svg';
import productCreationImg from './inventoryPageAssets/product-creation-img.svg';
import paystackIcon from './adsPageAssets/paystack-icon.svg';
import placeholder from './placeholder-image.svg';

export default {
  walletBalanceIcon,
  monthlySpendingIcon,
  totalPurchaseIcon,
  earnedRewardsIcon,
  referralsSentIcon,
  verifiedStoresIcon,
  checkChatIcon,
  addProductsIcon,
  viewOrdersIcon,
  createAdsIcon,
  productCreationImg,
  paystackIcon,
  placeholder,
};
